<template>
  <div class="note-suggested-actions">
    <div
      v-if="suggestedActions.length === 0"
      class="p-4 text-center text-inactive-text box-border"
    >
      {{ translate('noSuggestedActions') }}
    </div>
    <div
      v-else
      class="note-suggested-actions-wrap"
    >
      <NoteSuggestedAction
        v-for="action in suggestedActions"
        :key="action.id"
        :action="action"
        @accept="handleAccept"
        @reject="handleReject"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import NoteSuggestedAction from '@/components/notes/NoteSuggestedAction';
import useTranslate from '@/utilities/composables/useTranslate';
import { PropType } from 'vue';
import { AIGeneratedAction } from '@superthread-com/api';

const { translate } = useTranslate();

defineProps({
  suggestedActions: {
    type: Array as PropType<AIGeneratedAction[]>,
    required: true,
    default: () => [],
  },
});

const emit = defineEmits(['accept', 'reject']);

const handleAccept = (action: any) => {
  emit('accept', action);
};

const handleReject = (action: any) => {
  emit('reject', action);
};
</script>

<style lang="scss">
.note-suggested-actions {
  width: $noteSuggestedActionItemWidth;
  @apply flex flex-col;

  & > div {
    @apply w-full;
  }

  .note-suggested-actions-wrap {
    @apply flex flex-col gap-3;
  }
}
</style>
